import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { UserProvider } from '@fff-web/fff-utilities';
import './index.css';
import App from './App';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};
TagManager.initialize({
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </StrictMode>,
);
